import {schema} from 'normalizr';

const keycloakUserSchema = new schema.Entity('keycloak/user', {});
const keycloakCompanySchema = new schema.Entity('keycloak/company', {});

export {keycloakCompanySchema, keycloakUserSchema};
